import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";

import { FaCheckSquare } from "react-icons/fa";

import QueAns from "./QueAns";
import Loading from "./Loading";

import { AuthContext } from "../store/AuthProvider";

import "./css/components.css";

const Questions = (props) => {
  //using user context
  const { _, userState } = useContext(AuthContext);
  const [userAuthToken, setUserAuthToken] = userState;
  // change below to make question quanta variable
  const snum = props.match.params.snum;
  const quanta = props.match.params.quanta;
  const questionType = props.match.params.questionType;
  const sessionStart = 1 + quanta * snum;
  const sessionEnd = sessionStart + (quanta - 1);

  const taskId = props.match.params.taskId;
  const sessionNum = parseInt(props.match.params.snum) + 1;

  const [questionsMap, setQuestionsMap] = useState({});
  const [questions, setQuestions] = useState([]);
  const [taskName, setTaskName] = useState("");

  const [mssg, setMssg] = useState("Loading...");

  // console.log("Q", questions, questions.length);

  const updateData = (data) => {
    if (Object.keys(data).includes("error")) {
      setMssg(data.error);
    } else {
      setQuestionsMap(data.response.questions);
      setQuestions(Object.values(data.response.questions));
      setTaskName(data.response.task_name);
    }
  };

  useEffect(() => {
    const getQDetails = async () => {
      let qURL = `${process.env.REACT_APP_API}/task/${props.match.params.taskId}/questions?start_index=${sessionStart}&end_index=${sessionEnd}&auth_token=${userAuthToken}&question_type=${questionType}`;
      console.log("question url:", qURL)
      const response = await fetch(qURL);
      const data = await response.json();
      updateData(data);
    };
    getQDetails();
  }, []);

  if (questions.length === 0) {
    return <Loading message={mssg} />;
  }
  return (
    <div className="mainSpace">
      <div className="breadCrumbs">
        <Link to="/">
          <span className="spChar">H</span>ome
        </Link>
        <span className="spChar spaceAround">/</span>
        <Link to={`/task=${taskId}`}>
          <span className="spChar">{taskName.slice(0, 1)}</span>
          {taskName.slice(1)}
        </Link>
        <span className="spChar spaceAround">/</span>
        <span className="spChar">S</span>ession{" "}
        <span className="spChar">{sessionNum}</span>
      </div>

      <Tab.Container id="left-tabs" defaultActiveKey="0">
        <Row className="mainContent">
          <Col sm={3} className="enableScroll">
            <Nav variant="pills" className="flex-column">
              {questions.map((question, index) => (
                <QueItem
                  done={question.annotation_done}
                  index={index}
                  key={index}
                />
              ))}
              <Nav.Item style={{ marginTop: "2em" }}>
                <Link
                  to="#"
                  onClick={() => {
                    props.history.goBack();
                  }}
                >
                  <Nav.Link href={`#/task=${taskId}`}>Back</Nav.Link>
                </Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col sm={8}>
            <Tab.Content>
              {questions.map((question, index) => (
                <QueAns
                  key={index}
                  taskId={taskId}
                  question={question}
                  index={index}
                  questionsMap={questionsMap}
                  setQuestionsMap={setQuestionsMap}
                />
              ))}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};

const QueItem = ({ done, index }) => (
  <Nav.Item>
    <Nav.Link eventKey={index}>
      <div className="QNum">
        Q. {parseInt(index) + 1}
        {done && <FaCheckSquare size={28} />}
      </div>
    </Nav.Link>
  </Nav.Item>
);

export default Questions;
